var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoUsUnofficial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2366,
    height: 582,
    viewBox: "0 0 2366 582",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2365.55 0H2142.81V48.4453H2365.55V0Z",
    fill: "#039C00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2123.41 0H2074.99V581.07H2123.41V0Z",
    fill: "#039C00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2365.55 532.66H2142.81V581.071H2365.55V532.66Z",
    fill: "#039C00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2307.46 266.346H2142.81V314.757H2307.46V266.346Z",
    fill: "#039C00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1737.27 0H1688.86V581.07H1737.27V0Z",
    fill: "#039C00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1979.41 0H1756.68V48.4453H1979.41V0Z",
    fill: "#039C00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1921.33 266.346H1756.68V314.757H1921.33V266.346Z",
    fill: "#039C00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1351.18 0H1302.73V581.07H1351.18V0Z",
    fill: "#039C00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1593.29 72.6338V581.07H1544.87V314.758H1370.52V266.347H1544.87V72.6338C1544.87 59.2754 1534.04 48.4453 1520.65 48.4453H1370.52V0H1520.65C1529.16 0 1537.29 1.46907 1544.87 4.16807C1565.51 11.4451 1581.88 27.8099 1589.15 48.4453C1591.82 55.9956 1593.29 64.1609 1593.29 72.6338Z",
    fill: "#039C00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1207.16 0V48.4453H989.24C975.881 48.4453 965.05 59.2754 965.05 72.6337V314.758H916.602V72.6337C916.602 64.1609 918.071 55.9956 920.736 48.4453C928.013 27.7757 944.379 11.4109 965.05 4.13391C972.601 1.46907 980.767 0 989.24 0H1207.16Z",
    fill: "#039C00"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1207.16 266.346V508.436C1207.16 516.943 1205.69 525.074 1203.02 532.658C1195.74 553.294 1179.38 569.624 1158.74 576.901C1151.16 579.6 1143.02 581.069 1134.52 581.069H916.602V532.658H1134.52C1147.91 532.658 1158.74 521.828 1158.74 508.436V266.346H1207.16Z",
    fill: "#039C00"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M820.994 0H772.527V581.044H820.994V0Z",
    fill: "#039C00"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M434.937 0H386.488V581.07H434.937V0Z",
    fill: "#039C00"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M677.041 72.6338V581.07H628.627V72.6338C628.627 59.2754 617.796 48.4453 604.402 48.4453H454.273V0H604.402C612.91 0 621.042 1.46907 628.627 4.16807C649.263 11.4451 665.629 27.8099 672.907 48.4453C675.572 55.9956 677.041 64.1609 677.041 72.6338Z",
    fill: "#039C00"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M290.909 0H242.461V581.07H290.909V0Z",
    fill: "#039C00"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M223.123 532.659V581.07H72.9941C64.4865 581.07 56.3548 579.601 48.7698 576.902C28.1331 569.625 11.7672 553.294 4.48965 532.659C1.82464 525.074 0.355469 516.943 0.355469 508.436V0H48.7698V508.436C48.7698 521.829 59.6007 532.659 72.9941 532.659H223.123Z",
    fill: "#039C00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoUsUnofficial);
export default __webpack_public_path__ + "static/media/Logo_US_unofficial.99477ade9c56aa3cae96f740304bab27.svg";
export { ForwardRef as ReactComponent };